import React from "react";

interface ContentCardProps {
  children: React.ReactNode;
  title?: string;
  padding?: 'sm' | 'md' | 'lg';
  className?: string;
}

const ContentCard: React.FC<ContentCardProps> = ({
  children,
  title,
  padding = 'md',
  className = "",
}) => {
  const paddingClasses = {
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8'
  };

  return (
    <div className={`sf-card ${paddingClasses[padding]} ${className}`}>
      {title && (
        <div className="mb-6">
          <h2 className="text-xl font-bold text-fg-bright">
            {title}
          </h2>
          <div className="mt-3 sf-divider"></div>
        </div>
      )}
      
      <div className="space-y-4">
        {children}
      </div>
    </div>
  );
};

export default ContentCard;